export var containerClassName = function (theme) {
    if (theme === void 0) { theme = {}; }
    return theme['galleryPlugin'];
};
//# sourceMappingURL=classNameStrategies.js.map